import { valueToPlatformId } from '../constants';
import type { IShareButtonProps } from '../types';

const getPlatformIdWithFallback = (
  platformId: IShareButtonProps['platformId'],
  value: IShareButtonProps['value'],
) => (platformId ? platformId : valueToPlatformId[value]);

export default getPlatformIdWithFallback;
